/** Status values for active and inactive. */
export default {
  // NOTE: This diverges from SNMP spec. Should be changed when possible.
  inactive: 0,
  active: 1,
};
